import ReactMarkdown from 'react-markdown'

export default function ResearchSummaryCard({ data, loading }) {
  if (loading) {
    return (
      <div className="card bg-base-100 shadow-xl">
        <div className="card-body">
          <h2 className="card-title">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75M18 15v3.75a2.25 2.25 0 01-2.25 2.25h-10.5A2.25 2.25 0 013 16.5V4.125C0 2.953.953 2.25 2.25 2.25h9.75c1.125 0 2.25.563 2.25 1.875V6.75l3.75 3.75" />
            </svg>
            Research Summary
          </h2>
          <div className="flex justify-center py-4">
            <span className="loading loading-spinner loading-md"></span>
          </div>
        </div>
      </div>
    )
  }

  if (!data) return null

  const { total_documents, agents_completed, agents_failed } = data

  return (
    <div className="card bg-base-100 shadow-xl">
      <div className="card-body">
        <h2 className="card-title">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75M18 15v3.75a2.25 2.25 0 01-2.25 2.25h-10.5A2.25 2.25 0 013 16.5V4.125C0 2.953.953 2.25 2.25 2.25h9.75c1.125 0 2.25.563 2.25 1.875V6.75l3.75 3.75" />
          </svg>
          Research Summary
        </h2>
        
        <div className="stats stats-vertical lg:stats-horizontal shadow">
          <div className="stat">
            <div className="stat-figure text-primary">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
              </svg>
            </div>
            <div className="stat-title">Total Documents</div>
            <div className="stat-value text-primary">{total_documents}</div>
            <div className="stat-desc">Documents found</div>
          </div>
          
          <div className="stat">
            <div className="stat-figure text-success">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div className="stat-title">Agents Completed</div>
            <div className="stat-value text-success">{agents_completed}</div>
            <div className="stat-desc">Successfully finished</div>
          </div>
          
          {agents_failed > 0 && (
            <div className="stat">
              <div className="stat-figure text-error">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                </svg>
              </div>
              <div className="stat-title">Agents Failed</div>
              <div className="stat-value text-error">{agents_failed}</div>
              <div className="stat-desc">Encountered errors</div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}